import { AuthActionType } from '../actionTypes';
import { SuSyApi } from '../../api/susyApi';
import { AuthAction } from '../actions';
import { Dispatch } from 'redux';
import { PostDispatch, User } from '../types';
import { PasswordChangeRequest } from 'susy-common/models';

export const getCurrentUser = () => async (dispatch: Dispatch<AuthAction>) => {
    const response = await SuSyApi.get('/authentication/currentUser');

    dispatch({
        type: AuthActionType.GET_CURRENT_USER,
        payload: response.data,
    });
};

export const externalSupervisorSignUp =
    (user: User, file: File | null, invitationId: string) =>
    async (dispatch: Dispatch<PostDispatch>) => {
        const formData = new FormData();

        if (!file || !invitationId) {
            return;
        }
        formData.append(`externalSupervisorSignUp_fileOfProof[]`, file);
        formData.append('user', JSON.stringify(user));
        const response = await SuSyApi.post(
            `/user/${invitationId}/supervisorSignUp`,
            formData
        );

        dispatch({
            type: AuthActionType.SUPERVISOR_SIGN_UP,
            payload: response.data,
        });
    };

export const changePassword = async (params: PasswordChangeRequest) => {
    await SuSyApi.post(`/authentication/changePassword`, params);
};
